import { Controller } from "@hotwired/stimulus"

// Associates the Better Stack browser session with the signed-in user.
//
// Privacy: only internal identifiers are sent — never a name, never an email
// address. See docs/superpowers/specs/2026-07-21-better-stack-observability-design.md
//
// Runs on every Turbo navigation because Stimulus reconnects, which is what
// clears the identity on the first page load after sign-out. Inline <head>
// scripts do not re-execute under Turbo Drive and could not do this.
export default class extends Controller {
  static values = {
    userId: String,
    workspaceId: String,
    plan: String,
    role: String,
    locale: String
  }

  connect() {
    if (typeof window.betterstack !== "function") return

    if (!this.userIdValue) {
      window.betterstack("user", null)
      return
    }

    // group_id, never group_name: the workspace name is the company name, and a
    // sole trader's company name is their own. See better_stack_helper.rb.
    const user = { id: this.userIdValue }
    if (this.workspaceIdValue) user.group_id = this.workspaceIdValue

    // Closed vocabularies, not free text — a plan slug, a role enum, a locale
    // code. Each is omitted rather than sent empty so a missing value never
    // reads as a real one in a Better Stack filter.
    if (this.planValue) user.plan = this.planValue
    if (this.roleValue) user.role = this.roleValue
    if (this.localeValue) user.locale = this.localeValue

    window.betterstack("user", user)
  }
}
